<script context="module" lang="ts">
    declare let Html5QrcodeScanner: any;
    declare let Html5QrcodeSupportedFormats: any;
</script>

<script lang="ts">
    // import QrScanner from "html5-qrcode";
    import { onMount } from "svelte";
    import { useNavigate, useResolve } from "svelte-navigator";
    import {
        Button,
        Notification,
        Tag,
    } from "../../../../../node_modules/svelma/src";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { locationStore } from "../../../../store/locations";
    import { networkStore } from "../../../../store/networks";
    import { player, user } from "../../../../store/stores";
    import QrScanModule from "./Components/QRScanModule.svelte";

    let registered: boolean = false;
    let activeQrScan = false;
    let qrResult: any;
    let qrUrlSearchParams: any;

    export let networkId: string;
    export let locationId: string;

    let navigate = useNavigate();
    let resolve = useResolve();

    const validateQrResult = (qrString: any) => {
        try {
            qrUrlSearchParams = new URL(qrString).searchParams;
            qrResult = {
                fingerprint: qrUrlSearchParams.get("fingerprint"),
                playerId: qrUrlSearchParams.get("playerid"),
                token: qrUrlSearchParams.get("token"),
            };
            console.log(qrResult);
            activeQrScan = false;
            player.update((playerStore) => {
                return {
                    ...playerStore,
                    fingerprint: qrResult.fingerprint,
                    uuid: qrResult.playerId,
                    token: qrResult.token,
                };
            });
            getPlayerStatus();
        } catch (error) {
            qrResult = {
                message: "QR-Code nicht valide",
            };
        }
    };

    const getPlayerStatus = async () => {
        if ($player.fingerprint && $player.uuid) {
            await fetch(
                "https://keycloak-dev.whizad.io/provision/check/" +
                    $player.fingerprint +
                    "/" +
                    $player.uuid,
                {
                    method: "GET",
                    headers: {
                        Authorization: "Bearer " + $user.token,
                    },
                }
            )
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.confirmationStatus === "CONFIRMED") {
                        registered = true;
                        // navigate("./configure");
                        return;
                    }
                    registered = false;
                });
        }
    };

    const getLocation = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .locationClient.getLocation({ locationId: locationId })
                .then((location) => {
                    locationStore.update((store) => {
                        return {
                            ...store,
                            location: location,
                        };
                    });
                });
        });
    };

    const getNetwork = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .networkClient.getNetwork({ networkId: networkId })
                .then((network) => {
                    networkStore.update((store) => {
                        return {
                            ...store,
                            network: network,
                        };
                    });
                });
        });
    };

    onMount(async () => {
        // QrScanner.WORKER_PATH = "/qr-scanner-worker.min.js";
        // qrScanner = new Html5QrcodeScanner(
        //     "reader",
        //     {
        //         qrbox: 320,
        //         formatsToSupport: [Html5QrcodeSupportedFormats.QR_CODE],
        //     },
        //     false
        // ) as any;
        getPlayerStatus();
        if (
            !$locationStore.location ||
            $locationStore.location.id !== locationId
        ) {
            getLocation();
        }
        if (!$networkStore.network || $networkStore.network.id !== networkId) {
            getNetwork();
        }
    });
</script>

<main>
    <div class="card fullwidth fullheight">
        <div class="card-content">
            <div class="content">
                <span
                    class="icon right-top-corner"
                    on:click={() => resolve("../")}
                >
                    <i class="fas fa-times" />
                </span>
                <p><b>Player-ID:</b> {$player.uuid}</p>
                <p><b>Token:</b> {$player.token}</p>
                <div class="status">
                    <b>Status:</b>
                    <Tag
                        class="inline"
                        type={registered ? "is-primary" : "is-danger"}
                    >
                        {registered ? "Registered" : "not registered"}</Tag
                    >
                </div>
                <br />
                <QrScanModule {validateQrResult} />

                <!-- {#if registered} -->
                <Button
                    on:click={() =>
                        navigate(
                            qrUrlSearchParams.get("playerid") +
                                "/configure?" +
                                qrUrlSearchParams.toString()
                        )}>Player Konfigurieren</Button
                >
                <!-- {:else} -->

                <!-- {/if} -->
                <br />
                {#if activeQrScan}
                    <div
                        class="modal {activeQrScan
                            ? 'is-active'
                            : null} qr-container"
                    >
                        <div
                            class="modal-background"
                            on:click={() => {
                                // qrScanner.stop();
                                activeQrScan = false;
                            }}
                        >
                            <div class="modal-content" />
                        </div>
                        <button
                            class="modal-close is-large"
                            aria-label="close"
                        />
                    </div>
                {/if}
                <!--
                

                    <div
                        class="modal-background"
                        on:click={() => {
                            // qrScanner.stop();
                            activeQrScan = false;
                        }}
                    />
                    <div class="modal-content">
                        {#if qrResult && qrResult.message}
                            <div class="block">
                                {qrResult.message}
                            </div>
                        {:else}
                            svelte-ignore a11y-media-has-caption
                            <div id="reader" width="600px" />
                        {/if}
                    </div>
                    <button class="modal-close is-large" aria-label="close" />
                </div>-->
            </div>
        </div>
    </div>
</main>

<style>
    main {
        text-align: center;
        padding: 1em;
        max-width: 1024px;
        margin: 0 auto;
    }
    .status {
        margin-bottom: 1rem;
    }

    .content {
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .right-top-corner {
        position: absolute;
        top: 5px;
        right: 5px;
        cursor: pointer;
    }
</style>
